import 'slick-carousel'

;(function($) {
    $(function() {
        
        let slider = '.gallery-slider';
        
        $(slider).slick(
            {
                dots: false,
                infinite: true,
                speed: 300,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                centerMode: false,
                responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '10%',
                        slidesToShow: 1
                      }
                    },
                    {
                      breakpoint: 922,
                      settings: {
                        arrows: true,
                        centerMode: true,
                        slidesToShow: 1,
                        centerPadding: '20%',
                      }
                    }
                ]
            }
        );
    });
})(jQuery)